var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignedWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5020_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0016 7.28341C11.7726 7.28341 12.3977 6.65834 12.3977 5.88731C12.3977 5.11628 11.7726 4.49121 11.0016 4.49121C10.2305 4.49121 9.60547 5.11628 9.60547 5.88731C9.60547 6.65834 10.2305 7.28341 11.0016 7.28341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 0.000976562H3.66672C1.62833 0.0170898 -0.0121355 1.68054 6.76487e-05 3.71898V14.8748C-0.0121355 16.9133 1.6282 18.5771 3.66672 18.5937H6.34612L9.78178 21.527C10.4623 22.149 11.5022 22.1581 12.1935 21.5481L15.7181 18.5928H18.3334C20.3719 18.5761 22.0122 16.9124 22 14.8739V3.71898C22.0123 1.68054 20.3718 0.0170898 18.3334 0.000976562ZM11.0001 2.78948C15.2305 2.90132 15.2296 9.18507 11.0001 9.29782C6.76967 9.18503 6.77057 2.90403 11.0001 2.78948ZM14.895 15.775C14.4044 15.9001 13.9053 15.6039 13.7801 15.1134C13.7796 15.1111 13.779 15.109 13.7785 15.1067C13.3093 13.572 11.6848 12.7082 10.1501 13.1774C9.22623 13.4598 8.50315 14.1829 8.22072 15.1067C8.09263 15.5968 7.59153 15.8902 7.10147 15.7621C6.61141 15.634 6.31798 15.1329 6.44607 14.6429C7.15488 12.1275 9.76858 10.663 12.2839 11.3718C13.8693 11.8186 15.1082 13.0575 15.555 14.6429C15.6826 15.1374 15.3882 15.6424 14.895 15.775Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5020_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedWork);
export default __webpack_public_path__ + "static/media/assigned-work.e4242657a438e403db336e6cd9dc5a0f.svg";
export { ForwardRef as ReactComponent };